import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const PARTICIPANT_MOVE_CATEGORY_REQUEST = 'PARTICIPANT_MOVE_CATEGORY_REQUEST';
export const PARTICIPANT_MOVE_CATEGORY_SUCCESS = 'PARTICIPANT_MOVE_CATEGORY_SUCCESS';
export const PARTICIPANT_MOVE_CATEGORY_FAILURE = 'PARTICIPANT_MOVE_CATEGORY_FAILURE';

/**
 * MOVE (or COPY) AN ATHLETE'S ENTRY INTO ANOTHER CATEGORY of the same
 * competition — the mandate commission's correction.
 *
 * `keepInSource` is the organiser's question answered: false removes the
 * entry from the old category, true leaves it there and adds a second one.
 * An athlete legitimately competes in several categories, so neither answer
 * is the obvious default and the UI asks every time.
 *
 * Every rule lives on the backend — who may do it, and the refusal when
 * either category already has a draw. This action reports what the backend
 * decided; it never decides anything itself.
 */
export const moveParticipantCategory = (participantId, targetCategoryId, keepInSource = false) => {
    return function(dispatch) {
        dispatch({ type: PARTICIPANT_MOVE_CATEGORY_REQUEST, participantId });

        return axios(apiRequestOptions(
            apiPath.PARTICIPANT.MOVE_CATEGORY,
            { targetCategory: targetCategoryId, keepInSource },
            { params: { id: participantId } },
        ))
            .then(transformHttpResponse)
            .then(response => {
                dispatch({
                    type: PARTICIPANT_MOVE_CATEGORY_SUCCESS,
                    participantId,
                    targetCategoryId,
                    keepInSource,
                    data: response.data,
                });

                return response.data;
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: PARTICIPANT_MOVE_CATEGORY_FAILURE, participantId, error });
                dispatch(errorRequestHandler(error));

                throw error;
            });
    };
};
